import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Person from '@material-ui/icons/Person';
import styled from 'styled-components';

const TRWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const CustomAvatar = styled(Avatar)`
  &&& {
    width: 30px;
    height: 30px;
  }
`;
const NameWrapper = styled.span`
  margin-left: 10px;
`;
const TableUser = props => {
  return (
    <TRWrapper>
      {props.img !== '-' ? (
        <CustomAvatar alt={props.name} src={props.img} />
      ) : (
        <Person />
      )}
      <NameWrapper>{props.name}</NameWrapper>
    </TRWrapper>
  );
};
export default TableUser;
